
import {
  Vue,
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import {
  Dialog,
  Steps,
  Step,
  Button,
} from 'element-ui';
import { IMatchForm } from '@/types/match.d';
import api from '@/api/course';
import moment from 'moment';
import FormMixin from './formMixin';
import firstStep from './firstStep.vue';
import secondStep from './secondStep.vue';
import thirdStep from './thirdStep.vue';

@Component({
  components: {
    Dialog,
    Button,
    Steps,
    Step,
    firstStep,
    secondStep,
    thirdStep,
  },
})
export default class ManageBusModal extends Vue {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: true,
    default: 0,
  }) editType!: number;

  @Prop({
    required: false,
    default: '添加赛事',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private steps: Array<{ title: string, icon: string }> = [
    {
      title: '基本信息',
      icon: '',
    },
    {
      title: '添加资源',
      icon: '',
    },
  ];

  private curModalComp: string = 'firstStep';

  private lastLoading: boolean = false;

  private nextLoading: boolean = false;

  private chapterData: any = {};

  public $refs!: {
    stepComp: firstStep | secondStep,
    chapterContent: thirdStep,
  }

  get getTitle() {
    let edit = {
      0: '富文本',
      1: 'Markdown',
      2: 'Markdown',
    }
    return `${this.title} - ${edit[this.editType]}`
  }

  get stepActive() {
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'firstStep': return 1;
      case 'secondStep': return 2;
    }
    return 1;
  }

  get matchData() {
    return this.oldForm;
  }

  /**
   * @author liangyongmou
   * @desc 点击下一步
   * @param 空
   */
  nextStep() {
    /* eslint-disable default-case */
    switch (this.curModalComp) {
      case 'firstStep': this.handleFirst(); break;
      case 'secondStep': this.handleSecond(); break;
      // case 'thirdStep': this.handleThird(); break;
    }
  }

  /**
   * @author iangyongmou
   * @desc 第一步提交
   * @param 空
   */
  handleFirst() {
    const form = this.$refs.stepComp.handleSubmit();
    if (Object.keys(form).length !== 0) {
      this.chapterData = form;
      this.curModalComp = 'secondStep';
    }
  }

  /**
   * @author iangyongmou
   * @desc 第二步提交
   * @param 空
   */
  handleSecond() {
    const form = this.$refs.stepComp.handleSubmit();
    if (this.chapterData.scratchVersion === 2) {
      const {
        backdropLibrary,
        costumeLibrary,
        soundLibrary,
        spriteLibrary,
      } = form;
      this.chapterData = {
        ...this.chapterData,
        backdropLibrary,
        costumeLibrary,
        soundLibrary,
        spriteLibrary,
      };
    } else {
      const {
        backdropLibrary: V3BackdropLibrary,
        costumeLibrary: V3CostumeLibrary,
        soundLibrary: V3SoundLibrary,
        spriteLibrary: V3SpriteLibrary,
      } = form;
      this.chapterData = {
        ...this.chapterData,
        V3BackdropLibrary,
        V3CostumeLibrary,
        V3SoundLibrary,
        V3SpriteLibrary,
      };
    }
    this.handleThird();
    // this.curModalComp = 'thirdStep';
  }

  /**
   * @author iangyongmou
   * @desc 第三步提交
   * @param 空
   */
  handleThird() {
    const form = this.$refs.stepComp.handleSubmit();
    if (Object.keys(form).length !== 0) {
      this.chapterData.stepPoints = form.stepPoints;
    }
    this.chapterData.coursePid = Base64.decode(this.$route.params.pid);
    const data = new FormData();
    Object.keys(this.chapterData).forEach((key) => {
      if (this.chapterData[key] || this.chapterData[key] === 0) {
        data.append(key, this.chapterData[key]);
      }
    });
    this.nextLoading = true;
    if (this.title.includes('修改')) {
      api.editChapter(data).then(() => {
        this.reset(true, true);
        this.nextLoading = false;
      /* eslint-disable no-return-assign */
      }).catch(() => (this.nextLoading = false));
    } else {
      api.addChapter(data).then(() => {
        this.reset(true, true);
        this.nextLoading = false;
      /* eslint-disable no-return-assign */
      }).catch(() => (this.nextLoading = false));
    }
  }

  // 修改章节内容提交事件
  submitContent() {
    this.nextLoading = true;
    const form = this.$refs.chapterContent.handleSubmit();
    const data = new FormData();
    Object.keys(form).forEach((key) => {
      if (form[key] || form[key] === 0) {
        data.append(key, form[key]);
      }
    });
    console.log(data)
    api.updataChapterContent(data).then((res: any) => {
      this.reset(true, true);
      this.nextLoading = false;
    });
  }

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
  }
}
